import { NgModule } from '@angular/core';
import { ButtonComponent } from './button.component';



@NgModule({
  declarations: [ButtonComponent],
  imports: [
  ],
  exports: [ButtonComponent]
})
export class ButtonModule { }
